import React from 'react';
import { Headline, Text } from '@oneaudi/unified-web-components';
import { PriceGroupComponent } from './PriceGroup';
import { DialogStylingOverride, ModalHeader, PriceGroupStyles } from './pricebreakdown.styles';
import { SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_150 } from '@oneaudi/unified-web-common';
import { useI18n } from '@oneaudi/i18n-context';
import { DynamicComponent } from '../../../../utils';
export const PriceBreakdownModalContent = ({ vehicle, priceGroups, }) => {
    const visiblePriceGroups = priceGroups.filter((group) => group.items.some((item) => (item === null || item === void 0 ? void 0 : item.price) !== undefined && item.price !== null));
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogStylingOverride, null),
        React.createElement(ModalHeader, null,
            React.createElement(Headline, { tag: "h1", variant: {
                    type: 'headline',
                    order: '2',
                    weight: 'bold',
                } }, vehicle === null || vehicle === void 0 ? void 0 : vehicle.mbvHandbook.description),
            React.createElement(Headline, { tag: "h2", variant: {
                    type: 'headline',
                    order: '4',
                    weight: 'normal',
                } }, vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelCode.description)),
        React.createElement("section", null,
            React.createElement(Headline, { tag: "h2", margin: ['0px', '0px', SYS_SPACE_FIXED_200, '0px'], variant: {
                    type: 'headline',
                    order: '4',
                    weight: 'normal',
                } }, useI18n({ id: 'stockcars.pricebreakdown.headline', defaultMessage: '' })),
            visiblePriceGroups.map((group, groupIndex) => {
                const isSecondLastItem = groupIndex + 2 === visiblePriceGroups.length;
                const isLastItem = groupIndex + 1 === visiblePriceGroups.length;
                const hasPrices = group.items
                    .map((item) => (item === null || item === void 0 ? void 0 : item.price) !== undefined && item.price !== null)
                    .some((value) => value);
                if (!hasPrices)
                    return null;
                return (React.createElement(PriceGroupStyles, { isSecondLastItem: isSecondLastItem, isLastItem: isLastItem, key: group.label },
                    React.createElement(PriceGroupComponent, { priceGroup: group })));
            })),
        React.createElement(DynamicComponent, { legacy: React.createElement("section", null,
                React.createElement(Text, { tag: "p", variant: { order: '2', style: 'bold' }, margin: ['0px', '0px', SYS_SPACE_FIXED_150, '0px'] }, useI18n({ id: 'stockcars.pricebreakdown.footnotes.headline', defaultMessage: '' }))) })));
};
